export default __webpack_public_path__ + "static/media/logo2.aae2568b.png";